module.exports = __webpack_public_path__ + "assets/img/29-l.53f9fa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/29-l.jpg
// module id = Udk2
// module chunks = 0